import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiLink',
  props: {
  to: {
    type: String,
    default: null,
  },
  target: {
    type: String,
    default: null,
  },
  download: {
    type: [String, Boolean],
    default: false,
  },
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props;





const isExternalLink = computed(() => /^https?:/.test(props.to ?? ''));
const isSamePageLink = computed(() => props.to?.startsWith('#'));

const isNativeLink = computed(
  () => isExternalLink.value || isSamePageLink.value,
);

const linkTarget = computed(() =>
  props.target ?? isExternalLink.value ? '_blank' : '_self',
);

const onLinkClick = (e: MouseEvent) => {
  if (isSamePageLink.value) {
    e.preventDefault();

    document?.querySelector(props.to)?.scrollIntoView({
      behavior: 'smooth',
    });
  }

  emit('click');
};

return { __sfc: true,props, emit, isExternalLink, isSamePageLink, isNativeLink, linkTarget, onLinkClick }
}

})